import server from './server'
import { isEqual } from './utils'
import store from '../store/vuex'
import ttTaxIdToCompanyId from '../assets/doc/ttTaxIdToCompanyId.json'

/* eslint-disable */
// https://docs.google.com/spreadsheets/d/1xHvGvshOPPZawstl8fDj4_ul5JFs4C0sbgZ7yWACQlA/edit#gid=435244376
const gaEvents = {
  hasInit: false,
  hasInsertGaScript: false,
  gaSets: {
    'dimension1': '',
    // 'dimension2': '',
    'dimension3': '',
    // 'dimension4': '',
    'dimension5': '',
    'dimension7': '',
    'dimension8': ''
  },
  ttGaSets: {
    dimension1: '',
    dimension7: '',
    dimension10: '',
    dimension16: '',
    dimension17: ''
  },
  markerActionTranslate: {
    PointClicks: '站點',
    LinkClicks: '網頁',
    TeleportClicks: '傳送站點',
    TagAction: '標籤',
    TagClicks: '標籤',
    NarrationClicks: '語音',
    MemoClicks: '註記',
    GalleryClicks: '圖片',
    MultitagClicks: '群組標籤',
    VideoClicks: '影片',
    ZoomBySlider: '圖片縮放',
    ZoomByButton: '圖片縮放',
    ShowMarkerInfo: '顯示詳細資訊',
    CloseMarkerInfo: '關閉詳細資訊'
  },
  init (url = location.pathname) {
    if (!this.hasInsertGaScript) {
      const gaUrl = `https://www.googletagmanager.com/gtag/js?id=${server.ttGaId}`
      ;(function (i, s, o, g, r, a, m) {
        i['GoogleAnalyticsObject'] = r
        i[r] = i[r] || function () {
          (i[r].q = i[r].q || []).push(arguments)
        }, i[r].l = 1 * new Date()
        a = s.createElement(o),
          m = s.getElementsByTagName(o)[0]
        a.async = 1
        a.src = g
        m.parentNode.insertBefore(a, m)
      })(window, document, 'script', gaUrl, 'ga')
      // disable auto pageview
      gtag('config', server.ttGaId, {
        send_page_view: false,
        cookie_flags: 'max-age=7200;secure;samesite=none'
      })
      gtag('config', server.gaId, {
        send_page_view: false,
        cookie_flags: 'max-age=7200;secure;samesite=none'
      })
      gtag('config', server.ga4Id, {
        send_page_view: false,
        cookie_flags: 'max-age=7200;secure;samesite=none'
      })
      this.hasInsertGaScript = true
    }

    const username = store.state.user.user.username
    const companyName = store.state.user.user.companyDisplayName
    const headquarterId = store.state.user.headquarter.objectId
    const userHeadquarterId = store.state.user.user.headquarter.objectId
    const buildingId = store.state.route.params.buildingId || store.state.buildings.currentBuilding.objectId || ''
    const buildingName = store.state.buildings.currentBuilding.name || ''
    const propertyId = store.state.route.query.group || store.state.property.property.objectId || ''
    const shouldCheckProperty = store.state.route.query.group
    const shouldCheckHeadquarter = store.state.route.name !== 'default'
    const planTitle = store.state.user.user.planTitle
    // dimension1: username
    // dimension2: headquarterIdUrlHasTitle, had been deprecated
    // dimension3: headquarterId
    // dimension4: deviceType, had been deprecated
    // dimension5: buildingId
    // dimension6: sharecode, had been deprecated
    // dimension7: propertyId
    // dimension8: planTitle
    // dimension9: panoramaId <'buildingViews','__realPanoramaId__'>
    // dimension10: visitor username

    // user will have customSetting, headquarter default value
    // if (!Object.keys(user).length || !buildingId || (shouldCheckProperty && !propertyId)) {
    if (!username || !buildingId ||
      (shouldCheckProperty && !propertyId) ||
      (shouldCheckHeadquarter && (!headquarterId || !userHeadquarterId))) {
      return
    }
    const gaSets = {
      dimension1: store.state.user.user.username || '',
      // dimension2: store.state.user.headquarter.objectId || '',
      dimension3: store.state.user.user.headquarter.objectId || '',
      // dimension4: 'Web',
      dimension5: buildingId,
      dimension7: propertyId,
      dimension8: planTitle,
      dimension10: '',
      send_page_view: false,
      cookie_flags: 'max-age=7200;secure;samesite=none'
    }
    // RM#6563
    //   維度名稱					自訂維度					    值
    // Dimension1		meta-CompanyName		Api.CompanyName || user.companyDisplayName
    // Dimension2		meta-ProductName		Api.ProductName || marker.name
    // Dimension3		meta-IndustryName		Api.categoryTree 第三層
    // Dimension4		meta-CompanyID			Api.companyId
    // Dimension5		meta-ProductID			Api.pid
    // Dimension6		meta-IndustryID			Api.catelogStandardCid
    // Dimension7		meta-Language				"42"
    // Dimension8		meta-WebID					iStaging-<Api.companyId>
    // Dimension9		meta-CompanyVAT			Api.seq
    // Dimension10	meta-IndustryID2		buildingId
    // Dimension11	meta-IndustryID4		panoramaId
    // Dimension12	meta-IndustryID6		markerId
    // Dimension13	meta-IndustryName2	Api.categoryTree 第一層
    // Dimension14	meta-IndustryName4	Api.categoryTree 第二層
    // Dimension15	meta-IndustryName6	Api.categoryTree 第三層
    // Dimension16	DUNS								buildingName
    // Dimension17	meta-datasource			"VR"
    // Dimension18	meta-CurrentId			"NULL"
    // Dimension19	uid_collection			"NULL"
    // Dimension20	OnlineSaleStatus		Api.isSelling, 0為"N", 1為"Y"
    const ttGaSets = {
      dimension1: companyName || '',
      dimension7: '42',
      dimension10: buildingId,
      dimension16: buildingName,
      dimension17: 'VR',
      dimension18: 'NULL',
      dimension19: 'NULL',
      send_page_view: false,
      cookie_flags: 'max-age=7200;secure;samesite=none'
    }
    if (ttTaxIdToCompanyId[username]) {
      ttGaSets.dimension4 = ttTaxIdToCompanyId[username]
      ttGaSets.dimension8 = 'iStaging-' + ttTaxIdToCompanyId[username]
      ttGaSets.dimension9 = username
    }
    if (!isEqual(this.gaSets, gaSets)) {
      this.gaSets = gaSets
      this.ttGaSets = ttGaSets
      gtag('config', server.ttGaId, {...ttGaSets, dimension11: 'buildingViews'})
      gtag('config', server.gaId, {...gaSets, dimension9: 'buildingViews'})
      gtag('config', server.ga4Id, {...gaSets, dimension9: 'buildingViews'})
      gtag('event', 'page_view', {
        page_path: url
      })
      const panoramas = store.state.panoramas.panoramas
      if (panoramas.length > 0) {
        this.sendSceneView()
      }
    }
    this.hasInit = true
  },
  sendSceneView () {
    const url = location.pathname
    const panoramas = store.state.panoramas.panoramas
    const pageIndex = Number(store.state.route.query.index) || 1 // default from 1
    const dataIndex = pageIndex - 1
    const targetPanoramaId = panoramas[dataIndex].objectId

    // the setting (disable auto pageview) must be repeated on every page
    // https://developers.google.com/analytics/devguides/collection/gtagjs/pages#manual_pageviews
    gtag('config', server.ttGaId, {...this.ttGaSets, dimension11: targetPanoramaId})
    gtag('config', server.gaId, {...this.gaSets, dimension9: targetPanoramaId})
    gtag('config', server.ga4Id, {...this.gaSets, dimension9: targetPanoramaId})
    gtag('event', 'page_view', {
      page_path: url
    })
  },
  queuedEvents: [],
  sendEvent (category = '', action = '', label = '', markerName = '', customDimensions = '') {
    if (!this.hasInit) {
      // This is for handling the messy race conditions
      this.queuedEvents.push([
        category,
        action,
        label
      ])
      this.init()
    }
    if (this.hasInit) {
      if (category === 'Marker') {
        let customDimensionsObj = {}
        if (customDimensions) {
          customDimensionsObj = JSON.parse(customDimensions)
        }
        if (!customDimensionsObj.dimension1) {
          customDimensionsObj.dimension1 = store.state.user.user.companyDisplayName
        }
        if (!customDimensionsObj.dimension2) {
          customDimensionsObj.dimension2 = markerName
        }
        customDimensionsObj.dimension11 = store.state.panoramas.currentPanorama.objectId
        customDimensionsObj.dimension12 = this.markerActionTranslate[action] + '-' + label
        if (customDimensionsObj.dimension9) {
          delete customDimensionsObj.dimension9
        }
        gtag('config', server.ttGaId, {...this.ttGaSets, ...customDimensionsObj})
      }
      const visitorUsername = store.state.auth.username
      gtag('event', action, {
        event_category: category,
        event_label: label,
        dimension10: visitorUsername || ''
      })
      if (this.queuedEvents.length) {
        const event = this.queuedEvents.splice(0, 1)
        const [ec, ea, el] = event[0]
        this.sendEvent(ec, ea, el)
      }
      const shouldShowGaConsole = false
      if (shouldShowGaConsole) {
        console.log(`GA: ${category}, ${action}, ${label}`)
      }
    }
  }
}
/* eslint-enable */

export default gaEvents
